"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasRefugeeStatus = exports.hasAsylumStatus = exports.IMMIGRATION_STATUSES_REFUGEE = exports.IMMIGRATION_STATUSES_ASYLUM = void 0;

var lodash_1 = require("lodash"); // https://www.dhs.gov/immigration-statistics/lawful-permanent-residents/ImmigrantCOA
// TODO: we should really do all these statuses as enums


exports.IMMIGRATION_STATUSES_ASYLUM = ["AS6", "AS7", "AS8", "GA6", "GA7", "GA8", "SY6", "SY7", "SY8"];
exports.IMMIGRATION_STATUSES_REFUGEE = ["CU6", "CU7", "CU7", "IC6", "IC7", "R86", "M83", "Y64", "RE6", "RE7", "RE8", "RE9"]; //Note: this is temporarily deprecated, may need to bring back earlier but it turns out immigration status is much more freeform
//and the above listed stauses migh not be inclusive

var hasAsylumStatus = function hasAsylumStatus(statusStrOrArr) {
  var _a;

  var statuses = (0, lodash_1.castArray)(statusStrOrArr);
  return ((_a = (0, lodash_1.intersection)(exports.IMMIGRATION_STATUSES_ASYLUM, statuses)) === null || _a === void 0 ? void 0 : _a.length) > 0;
};

exports.hasAsylumStatus = hasAsylumStatus;

var hasRefugeeStatus = function hasRefugeeStatus(statusStrOrArr) {
  var _a;

  var statuses = (0, lodash_1.castArray)(statusStrOrArr);
  return ((_a = (0, lodash_1.intersection)(exports.IMMIGRATION_STATUSES_REFUGEE, statuses)) === null || _a === void 0 ? void 0 : _a.length) > 0;
};

exports.hasRefugeeStatus = hasRefugeeStatus;